<template>
  <b-modal
    :hide-footer="true"
    title="Autorização de Acolhimento"
    centered
    size="md"
    id="autorizacao-acolhimento"
    :visible="false"
    :no-close-on-backdrop="true"
    :tabindex="0"
  >
    <div>

        <div class="row">
            <div class="col-md-4">
                <form-input
                label="Data da Ação"
                type="date"
                v-model="solicitacao.data_acao"
                :required="true"
                />
            </div>

            <div class="col-md-8">
                <form-input
                label="Nome do Responsável"
                v-model="solicitacao.nome_responsavel"
                :required="true"
                />
            </div>
        </div>

        <div class="row">

            <div class="col-lg-12">
                <form-select
                    v-model="solicitacao.unidade_vaga"
                    label="Unidade"
                    :itens="unidadesFiltradas"
                    :multiple="false"
                    :loading="loadingUnidades"
                />
            </div>

            <div class="col-lg-12">
                <form-input
                    label="Nome do Usuário"
                    v-model="solicitacao.nome_usuario"
                    :required="true"
                    :readonly="true"
                />
            </div>

            <div class="col-lg-12">
                <form-input
                    label="Nome do Técnico Solicitante"
                    v-model="solicitacao.tecnico_solicitante"
                    :required="true"
                    :readonly="true"
                />
            </div>

            <div class="col-lg-12">
                <form-input
                  label="Unidade Solicitante"
                  :value="descricaoUnidadeSolicitante"
                  :readonly="true"
                />
            </div>
        </div>

      <div class="row pt-2 px-2 d-flex justify-content-end">
        <button @click="confirmarSolicitacao" class="btn btn-success btn-submit">
          <i class="fas fa-check-circle" />
          Confirmar Autorização
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["item", "unidades", "loadingUnidades", "todas_unidades"],
  data() {
    return {
      solicitacao: {
        unidade_vaga: [],
        unidade_solicitante: this.item?.unidade_solicitante || '',
        nome_usuario: this.item?.nome_usuario || '',
        tecnico_solicitante: this.item?.resp_solicitacao || '',
        data_acao: new Date().toISOString().substr(0, 10),
        nome_responsavel: this.item?.nome_responsavel || '',
        servico: this.item?.servico || '',
        unidade_vaga: this.item?.unidade_id || '',
        publico_alvo_id: this.item?.publico_alvo_id || '',
      },
      municipio: "",
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.solicitacao.unidade_solicitante = val?.unidade_solicitante || '';
        this.solicitacao.nome_usuario = val?.nome_usuario || '';
        this.solicitacao.tecnico_solicitante = val?.resp_solicitacao || '';
        this.solicitacao.unidade_vaga = val?.unidade_id || '';
      }
    }
  },
  mounted() {
    this.buscarMunicipio();
  },
  computed: {
    descricaoUnidadeSolicitante() {
      if (!Array.isArray(this.todas_unidades) || !this.todas_unidades.length) {
        return '';
      }
      const lista = this.municipio === 'guarulhos'
        ? this.$root.arrays.unidade_solicitante_guarulhos || []
        : this.todas_unidades || [];
      const unidade = lista.find(u => u.id == this.solicitacao.unidade_solicitante);
      return unidade ? unidade.value : this.solicitacao.unidade_solicitante;
    },
    unidadesFiltradas() {
      if (!Array.isArray(this.unidades)) return [];
      const publicoAlvoId = this.item?.publico_alvo_id;
      if (!publicoAlvoId) return this.unidades;

      const filtradas = this.unidades.filter(u => {
        return Array.isArray(u.publico_alvo) && u.publico_alvo.includes(Number(publicoAlvoId));
      });
      return filtradas;
    },
  },
  methods: {
    async buscarMunicipio() {
      try {
        this.municipio = this.$store.state.municipio.toLowerCase();
      } catch (error) {
        console.error("Erro ao buscar município:", error);
      }
    },
    confirmarSolicitacao() {
      if (!this.solicitacao.nome_responsavel || !this.solicitacao.data_acao || !this.solicitacao.unidade_vaga) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios.", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      let payload = {
        ...this.solicitacao,
        id: this.item.id
      };

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/acolhimento/solicitacao/autorizar`, payload)
        .then((response) => {
          ladda.stop();
          this.$bvModal.hide("autorizacao-acolhimento");

          this.$bvToast.toast(response.data.message || 'Solicitação excluída com sucesso!', {
            title: "Sucesso",
            variant: "success",
            solid: true,
          });

          setTimeout(() => window.location.reload(), 800);
        })
        .catch((error) => {
          ladda.stop();
          this.$bvToast.toast(
            error.response?.data?.message || 'Erro ao autorizar o acolhimento.',
            {
              title: "Erro",
              variant: "danger",
              solid: true,
            }
          );
        });
    }
  }
};
</script>
